import { useSchemaState } from 'contexts'
import { Customizations } from 'models'
import { defaultSchema } from 'utils/constants'

const useGetCurrentCustomization = () => {
  const { schema, currentTableKey } = useSchemaState()
  const defaultCustomizations = defaultSchema.tableMappings.find(
    (mapping) => mapping.tableName === currentTableKey,
  )?.customizations as Customizations
  const personnalCustomizations = schema.tableMappings.find(
    (mapping) => mapping.tableName === currentTableKey,
  )?.customizations as Customizations
  const currentCustomization = personnalCustomizations || defaultCustomizations
  return {
    currentCustomization,
  }
}

export default useGetCurrentCustomization
